import { useEffect } from 'react';

import { useNavigate } from 'react-router-dom';

export function useLinkRouteIntercept() {
  const navigate = useNavigate();

  // TODO: Talk to Clerk about this
  useEffect(() => {
    const handleLinkClick = (event: MouseEvent) => {
      const target = event.target;
      if (!target || !(target instanceof Element)) return;
      const link = target.closest('a');

      if (link) {
        const href = link.getAttribute('href');
        if (!href) return;
        const hrefUrl = new URL(href);
        const isRelative = hrefUrl.host === window.location.host;

        if (href.startsWith('/') || isRelative) {
          event.preventDefault();
          event.stopPropagation();
          navigate(hrefUrl.pathname + hrefUrl.search + hrefUrl.hash);
        }
      }
    };

    document.addEventListener('click', handleLinkClick, true);

    return () => {
      document.removeEventListener('click', handleLinkClick, true);
    };
  }, [navigate]);
}
